import { render, staticRenderFns } from "./AddPartnerComponent.vue?vue&type=template&id=327601a8&"
import script from "./AddPartnerComponent.vue?vue&type=script&lang=js&"
export * from "./AddPartnerComponent.vue?vue&type=script&lang=js&"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./AddPartnerComponent.vue?vue&type=style&index=1&id=327601a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports